export const templateNameLoadLimit = 100;
